export const reportsRacingMultipleCrewsSinglePiece = {
    namespaced: true,

    state: {
        filterFields: {
            crews: []
        },
        filter: {
            crews: []
        },
        table: {
            selectedSplit: 50,
            selectedTypes: [
                'accumulatedTime',
                'incrementTime',
                'speed',
                'pace',
                'prognostic',
                'strokeRate',
                'eWPS',
                'dps'
            ],
            sortOrder: null
        }
    },

    getters: {
        getFilter(state) {
            return state.filter;
        },

        getFilterFields(state) {
            return state.filterFields;
        },

        selectedSplit(state) {
            return state.table.selectedSplit;
        },

        selectedTypes(state) {
            return state.table.selectedTypes;
        },

        sortOrder(state) {
            return state.table.sortOrder;
        }
    },

    mutations: {
        setSelectedSplit(state, selectedSplit) {
            state.table.selectedSplit = selectedSplit;
        },

        setSortOrder(state, sortOrder) {
            state.table.sortOrder = sortOrder;
        },

        selectType(state, { event, type }) {
            const index = state.table.selectedTypes.indexOf(type);
            if (event) {
                index === -1 && state.table.selectedTypes.push(type);
            } else {
                index !== -1 && state.table.selectedTypes.splice(index, 1);
            }
        },

        toggleCrew(state, payload) {
            const indexOf = state.filter.crews.indexOf(payload.crew.id);

            if (payload.event && indexOf === -1) {
                Vue.set(state.filter.crews, state.filter.crews.length, payload.crew.id);
            } else if (!payload.event && indexOf !== -1) {
                state.filter.crews.splice(indexOf, 1);
            }
        },

        setFilterFieldsCrews(state, payload) {
            state.filterFields.crews = payload;
        },

        resetState(state) {
            state.filterFields = {
                crews: []
            };
            state.filter = {
                crews: []
            };
            state.table = {
                selectedSplit: 50,
                selectedTypes: [
                    'accumulatedTime',
                    'incrementTime',
                    'speed',
                    'pace',
                    'prognostic',
                    'strokeRate',
                    'eWPS',
                    'dps'
                ],
                sortOrder: null
            };
        }
    },

    actions: {
        toggleCrew({ commit }, payload) {
            commit('toggleCrew', payload);
        },

        setFilterCrews({ commit }, payload) {
            commit('setFilterFieldsCrews', payload);
            payload.forEach(crew => commit('toggleCrew', { event: true, crew }));
        }
    }
};

export default reportsRacingMultipleCrewsSinglePiece;
